import { Component, Input, OnChanges , CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TruncatePipe } from '@app/shared/pipes/truncate/truncate.pipe';
import { SafePipe } from '@app/shared/pipes/safe/safe.pipe';

@Component({
    selector: 'app-review-card',
    templateUrl: './program-review-card.component.html',
    styleUrls: ['./program-review-card.component.scss'],
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, IonicModule, TruncatePipe, SafePipe],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]})
export class ProgramReviewCardComponent implements OnChanges {
    @Input() review: any;
    content: any;
    noReviews = false;

    constructor() {}

    ngOnChanges() {
        /* empty */
    }

    getFirstName(name: any) {
        const fullname = name.split(' ');
        const firstName = fullname[0];
        return firstName;
    }
}
